
// Helper functions to determine subdomain context
export const getSubdomainType = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'portal.itmgmtsol.com') {
    return 'portal';
  }
  
  if (hostname === 'billing.itmgmtsol.com') {
    return 'billing';
  }
  
  // For localhost development, check pathname
  if (hostname.includes('localhost')) {
    if (window.location.pathname.startsWith('/portal')) {
      return 'portal';
    }
    if (window.location.pathname.startsWith('/billing')) {
      return 'billing';
    }
  }
  
  return 'main';
};

export const isPortalSubdomain = () => {
  return getSubdomainType() === 'portal';
};

export const isBillingSubdomain = () => {
  return getSubdomainType() === 'billing';
};

export const isMainDomain = () => {
  return getSubdomainType() === 'main';
};
